function positiveNumber(value: unknown) {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}

function compact(value: number) {
  return String(Number(value.toFixed(8)));
}

export function isPlausibleThbPerUsd(value: unknown) {
  const parsed = positiveNumber(value);
  return parsed !== null && parsed >= 20 && parsed <= 60;
}

export function thbPerUsdForForm(extractedRate: unknown, currentUsdThb: unknown) {
  if (isPlausibleThbPerUsd(extractedRate)) return compact(Number(extractedRate));
  if (isPlausibleThbPerUsd(currentUsdThb)) return compact(Number(currentUsdThb));
  return '';
}

export function fxRateToUsdFromThbPerUsd(value: unknown) {
  const parsed = positiveNumber(value);
  return parsed === null ? '' : String(1 / parsed);
}

export function thbPerUsdFromFxRateToUsd(value: unknown) {
  const parsed = positiveNumber(value);
  return parsed === null ? '' : compact(1 / parsed);
}
